<template>
    <div class="dml-articles-thumb" data-t="24.3">
        <span class="dml-articles-thumb__label">TRENDY</span>
        <span class="dml-articles-thumb__title">{{title}}</span>
        <ul class="dml-articles-thumb__list">
            <li v-for="article in articles"
                :key="article.id">
                <a :href="article.url"
                   data-ga="m_home.click_article_thumb"
                   :data-ga-label="article.title"
                   class="dml-article-thumb" rel="nofollow">
                    <picture class="dml-article-thumb__image-wrap">
                        <source media="(min-width: 1280px)" :data-srcset="article.pictures.largex1" />
                        <img class="dml-article-thumb__image lazy"
                             src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                             :data-srcset="article.pictures.smallx1"
                             :alt="article.title" />
                    </picture>
                    <div class="dml-article-thumb__description">
                        <div class="dml-article-thumb__details">
                            <span class="dml-article-thumb-details__date">{{article.addedDate}}</span>
                            <span class="dml-article-thumb-details__separator">&#183;</span>
                            <span class="dml-article-thumb-details__category">{{article.category}}</span>
                        </div>
                        <span class="dml-article-thumb__title">{{article.teaser}}</span>
                    </div>
                </a>
            </li>
        </ul>
        <a class="dml-articles-thumb__cta" href="/trendy" title="trendy" data-t="24.3.1" rel="nofollow">
            Przejdź do artykułów
            <dm-icon name="arrow-right" :width="16" :height="14" />
        </a>
    </div>
</template>
<script>
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-articles-thumb',
        components: {
            'dm-icon': IconComponent,
        },
        props: {
            title: {
                type: String,
                required: true
            },
            articles: {
                type: Array,
                required: true
            }
        },
    };
</script>
